<template>
  <!-- 需求订单  签订合同 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 需求订单  签订合同-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBack">店铺管理</span>
        <i class="el-icon-arrow-right firm-clickable"></i><span @click="handelBack">订单管理</span>
        <i class="el-icon-arrow-right firm-clickable"></i><span @click="handelBack">需求订单</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">签订合同(237445658411)</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 合同信息确认-->
        <div class="top-title">
          <p class="title">合同信息确认</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="contentBody">
          <div class="lineBody">
            <p class="title">最终价格（人民币）：</p>
            <div class="content">4000元</div>
          </div>
          <div class="lineBody">
            <p class="title">最终交付时间：</p>
            <div class="content">2024年12月12日</div>
          </div>
          <div class="lineBody">
            <p class="title">交付方式：</p>
            <div class="content">分为两期进行交付</div>
          </div>
        </div>
        <div class="contentBody" style="background: #fbfbfb">
          <div class="lineBody">
            <p class="title">一期交付：</p>
            <div class="content">交付35% 1500元</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              原型图：30张，xx功能，xx功能，xx功能等三大模块一共30张原型图。
            </div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              PRD文档：1份，xx功能，xx功能，xx功能等三大模块的所有内容。
            </div>
          </div>
        </div>
        <div class="contentBody">
          <div class="lineBody">
            <p class="title">二期交付：</p>
            <div class="content">交付65% 2500元</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              UI 图：50张，xx功能，xx功能，xx功能等三大模块中所对应的功能页面。
            </div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              系统网站：1份，将UI图以及原型设计的功能全部做进网站中。
            </div>
          </div>
        </div>
        <div class="contentBody" style="background: #fbfbfb">
          <div class="lineBody">
            <p class="title">服务人员：</p>
            <div class="content">产品经理：1名</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">UI设计：1名</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">前端开发：1名</div>
          </div>
        </div>
        <div class="contentBody">
          <div class="lineBody">
            <p class="title">请交付第一期金额：</p>
            <div class="content">
              <p class="EarnestMoney">1500元</p>
              <p class="btn">点击交付</p>
            </div>
          </div>
        </div>
        <!-- 签名 -->
        <div class="contentBody" style="background: #fbfbfb">
          <div class="lineBody">
            <p class="title">签名：</p>
            <div class="content">
              <div class="code">
                <div></div>
                <p>扫码二维码进行电子签名</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 下一步 -->
        <div class="btn-box">
          <p class="firm-clickable" @click="handelNext">确认</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {},
  components: {},
  created() {},
  destroyed() {},
  methods: {
    // 确定
    handelNext() {
      // 跳转确认合同页面 key传2表示是从需求订单签订合同中过去的
      this.$router.push({
        path: "/HelpShop/ContractVerify",
        query: { key: 2 },
      });
    },

    // 返回
    handelBack() {
      // 存入select 返回/HelpShop的同时获取到select  select中的数就是该页面所在的位置
    
      this.$router.push({
        path: "/HelpShop/ShopOrderSingle",
        query: { key: 2 },
      });
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    margin-bottom: 40px;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
// 内容主体
.contentBody {
  width: 100%;
  min-height: 30px;
  padding: 10px 0px 10px 0px;
  background: #eeeeee;
  .lineBody:nth-child(1) {
    margin-top: 0px;
  }
  .lineBody {
    width: 95%;
    min-height: 30px;
    line-height: 30px;
    margin-top: 10px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    .title {
      width: 260px;
      font-size: 14px;
      color: #666666;
      text-align: right;
    }
    .content {
      flex: 1;
      font-size: 12px;
      color: #333333;
      display: flex;
      .EarnestMoney {
        font-size: 16px;
        color: #fe574a;
      }
      .btn {
        width: 70px;
        height: 30px;
        line-height: 30px;
        background: #409eff ;
        border-radius: 5px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        // margin: auto 0;
        margin-left: 20px;
      }
      .code {
        width: 120px;
        height: 70px;
        div {
          width: 50px;
          height: 50px;
          background-image: url("../../../../../assets/imgs/erweima2.svg");
          background-size: 100% 100%;
          margin: 0 auto;
        }
        p {
          font-size: 10px;
          color: #666666;
          text-align: center;
        }
      }
    }
  }
}
.btn-box {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  p {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #409eff ;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
}
</style>
